module.exports = __webpack_public_path__ + "img/flowers10.17bc2e27.jpg";